/**
 * Protected Route Component
 * Redirects unauthenticated users to sign-in
 */

import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { LoadingSpinner } from "../LoadingSpinner";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isLoading, isSignedIn } = useAuth();
  const location = useLocation();

  // Show loading spinner while auth state is loading
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  // Redirect to sign-in if not authenticated, remembering where they were
  // headed so sign-in can send them back (e.g. a /journal CTA from the blog).
  if (!isSignedIn) {
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/sign-in" replace state={{ from }} />;
  }

  // Render protected content
  return <>{children}</>;
}
